import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const Info = ({ color = '#313634', ...rest }: Props) => {
  return (
    <Svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6 10.5H7.33333V6.5H6V10.5ZM6.66667 5.16667C6.85556 5.16667 7.01389 5.10278 7.14167 4.975C7.26944 4.84722 7.33333 4.68889 7.33333 4.5C7.33333 4.31111 7.26944 4.15278 7.14167 4.025C7.01389 3.89722 6.85556 3.83333 6.66667 3.83333C6.47778 3.83333 6.31944 3.89722 6.19167 4.025C6.06389 4.15278 6 4.31111 6 4.5C6 4.68889 6.06389 4.84722 6.19167 4.975C6.31944 5.10278 6.47778 5.16667 6.66667 5.16667ZM6.66667 13.8333C5.74444 13.8333 4.87778 13.6583 4.06667 13.3083C3.25556 12.9583 2.55 12.4833 1.95 11.8833C1.35 11.2833 0.875 10.5778 0.525 9.76667C0.175 8.95555 0 8.08889 0 7.16667C0 6.24444 0.175 5.37778 0.525 4.56667C0.875 3.75556 1.35 3.05 1.95 2.45C2.55 1.85 3.25556 1.375 4.06667 1.025C4.87778 0.675 5.74444 0.5 6.66667 0.5C7.58889 0.5 8.45555 0.675 9.26667 1.025C10.0778 1.375 10.7833 1.85 11.3833 2.45C11.9833 3.05 12.4583 3.75556 12.8083 4.56667C13.1583 5.37778 13.3333 6.24444 13.3333 7.16667C13.3333 8.08889 13.1583 8.95555 12.8083 9.76667C12.4583 10.5778 11.9833 11.2833 11.3833 11.8833C10.7833 12.4833 10.0778 12.9583 9.26667 13.3083C8.45555 13.6583 7.58889 13.8333 6.66667 13.8333ZM6.66667 12.5C8.15555 12.5 9.41667 11.9833 10.45 10.95C11.4833 9.91667 12 8.65555 12 7.16667C12 5.67778 11.4833 4.41667 10.45 3.38333C9.41667 2.35 8.15555 1.83333 6.66667 1.83333C5.17778 1.83333 3.91667 2.35 2.88333 3.38333C1.85 4.41667 1.33333 5.67778 1.33333 7.16667C1.33333 8.65555 1.85 9.91667 2.88333 10.95C3.91667 11.9833 5.17778 12.5 6.66667 12.5Z"
        fill={color}
      />
    </Svg>
  )
}

export default Info
